declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function insertIntoDataLayer(pushData: Record<string, unknown>) {
  window.dataLayer = window.dataLayer || [];

  /**
   * 現状想定している例外は、gaSendEvent()にgclidが渡されずundefinedになる場合のみ
   * gclidがlocalStorageから取得され、値がなかった時、nullとなる
   * その場合はnullを許容する
   *
   * @see {@link https://github.com/Findy/Yuffie/pull/6629#discussion_r1052917450} for the reason to allow null
   */
  if ('gclid' in pushData && pushData['gclid'] === undefined) {
    delete pushData['gclid'];
  }

  const userIdIfHas = pushData['userId'];
  if (
    Object.keys(pushData).includes('userId') &&
    (userIdIfHas === undefined || userIdIfHas === null || userIdIfHas === '')
  ) {
    const deletedUserIdPushData = { ...pushData };
    delete deletedUserIdPushData['userId'];
    if (Object.keys(deletedUserIdPushData).length > 0) {
      window.dataLayer.push(deletedUserIdPushData);
    }
    return;
  }
  window.dataLayer.push(pushData);
}
